// removed by extract-text-webpack-plugin
module.exports = {"mobileShow":"Gf64ea9 G18c4ca"};